module.exports = __webpack_public_path__ + "static/media/invoicingar_cc_pay_guide_3.7ad4a6af.png";